import axios from "axios";
import Swal from "sweetalert2";
import {
  baseUrl,
  defaultAddErrorMessage,
  defaultUpdateErrorMessage,
  errorTranslate,
  objectifyForDropdown,
} from "../util";

export const addRefrigerantToBusiness = ({
  businessId,
  type,
  nickname,
  pcs,
  capacity,
  gas_used,
  percentage_turned_on,
  leased,
  disposed,
  price_invoice,
  invoice_date,
  invoice_number,
  aircon,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    type: type,
    nickname: nickname,
    pcs: pcs,
    capacity: capacity,
    gas_used: gas_used,
    percentage_turned_on: percentage_turned_on,
    leased: leased,
    disposed: disposed,
    price_invoice: price_invoice || null,
    invoice_date: invoice_date || null,
    invoice_number: invoice_number || null,
    aircon: aircon,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/" + businessId + "/refrigerant",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const deleteRefrigerant = ({
  businessId,
  objectId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url: baseUrl + "/api/business/" + businessId + "/refrigerant/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const getRefrigerantList = ({
  businessId,
  objectId,
  objects,
  setObjects,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/refrigerant",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        response.data.data.map((data) => {
          data.leased = data.leased ? "Yes" : "No";
          data.disposed = data.disposed ? "Yes" : "No";
          data.refrigerant_type = objectifyForDropdown(data.refrigerant_type);
          data.gas_used = objectifyForDropdown(data.gas_used);
          data.aircon = objectifyForDropdown(data.aircon);
          return data;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};

export const updateRefrigerant = ({
  businessId,
  objectId,
  type,
  nickname,
  pcs,
  capacity,
  gas_used,
  percentage_turned_on,
  leased,
  disposed,
  price_invoice,
  invoice_date,
  invoice_number,
  aircon,
  objects,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    type: type,
    nickname: nickname,
    pcs: pcs,
    capacity: capacity,
    gas_used: gas_used,
    percentage_turned_on: percentage_turned_on,
    leased: leased,
    disposed: disposed,
    price_invoice: price_invoice || null,
    invoice_date: invoice_date || null,
    invoice_number: invoice_number || null,
    aircon: aircon,
  });

  var config = {
    method: "put",
    url: baseUrl + "/api/business/" + businessId + "/refrigerant/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          if (response.data.data.id == supply.id) {
            response.data.data.refrigerant_type = objectifyForDropdown(
              response.data.data.refrigerant_type
            );
            response.data.data.gas_used = objectifyForDropdown(
              response.data.data.gas_used
            );
            response.data.data.aircon = objectifyForDropdown(
              response.data.data.aircon
            );
            response.data.data.leased = response.data.data.leased
              ? "Yes"
              : "No";
            response.data.data.disposed = response.data.data.disposed
              ? "Yes"
              : "No";
            return response.data.data;
          }
          return supply;
        })
      );
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      setErrorMessage(error.response.data);
    });
};

export const getRefrigerant = ({
  businessId,
  objectId,
  objects,
  setObjects,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/refrigerant/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          const gotValue = response.data.data;

          if (gotValue.id == supply.id) {
            gotValue.leased = gotValue.leased ? "Yes" : "No";
            gotValue.disposed = gotValue.disposed ? "Yes" : "No";
            gotValue.refrigerant_type = objectifyForDropdown(
              gotValue.refrigerant_type
            );
            gotValue.gas_used = objectifyForDropdown(gotValue.gas_used);
            gotValue.aircon = objectifyForDropdown(gotValue.aircon);
            return gotValue;
          }
          return supply;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};
